import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Swal from "sweetalert2";
import { useState } from "react";
import { setAccessToken, setRefreshToken } from "../../../../storage/storage";
import { ButtonLoader2 } from "../../../../components/shared/ButtonLoaders";
import useCurrentUser from "../../../../services/useCurrentUser";

/************************************* Google ************************************/
export function SocialLogin() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const { getCurrentUser } = useCurrentUser();

  const handleGoogleSuccess = (credentialResponse) => {
    if (!credentialResponse.credential) {
      Swal.fire({
        icon: "error",
        text: "Google login failed: No credential returned",
        customClass: {
          confirmButton: "custom-red-button",
        },
      });
      return;
    }

    setLoading(true);
    axios
      .post(`${BASE_URL}/api/login-with-google/`, {
        token: credentialResponse.credential, // 👈 ID token (JWT)
      })
      .then((response) => {
        setLoading(false);
        setAccessToken(response.data.access);
        setRefreshToken(response.data.refresh);
        window.location.href = "/";
        getCurrentUser(response.data.access);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          text:
            error?.response?.data?.message ||
            "Oops! Something went wrong on our end. Please give us a moment to fix it. Feel free to try again later",
          customClass: {
            confirmButton: "custom-red-button",
          },
        });
      });
  };

  const handleGoogleError = () => {
    Swal.fire({
      icon: "error",
      text: "Oops! Something went wrong on our end. Please give us a moment to fix it. Feel free to try again later",
      customClass: {
        confirmButton: "custom-red-button",
      },
    });
  };

  return (
    <div className="flex items-center justify-center gap-2">
      {loading ? (
        <ButtonLoader2 />
      ) : (
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
        />
      )}

      {/* placeholders for FB + Apple */}
      <button onClick={() => {}} className="">
        <img src="/assets/icons/facebook.png" alt="Facebook" />
      </button>
      <button onClick={() => {}} className="">
        <img src="/assets/icons/apple.png" alt="Apple" />
      </button>
    </div>
  );
}
